'use client'

import { Button } from '@acko/button'
import { TextInput } from '@acko/text-input'
import { Typography } from '@acko/typography'
import styles from './page.module.css'

export interface BikeRegistrationFormProps {
  className?: string
  ctaText: string
  disclaimer: string
  heading?: string
  headingClassName?: string
  inputPlaceholder: string
  isFetching: boolean
  onBlur: () => void
  onChange: (value: any) => void
  onSubmit: () => Promise<void> | void
  registrationError: string
  regNumber: string
  showError: boolean
}

export const BikeRegistrationForm = ({
  className = '',
  ctaText,
  disclaimer,
  heading,
  headingClassName = '',
  inputPlaceholder,
  isFetching,
  onBlur,
  onChange,
  onSubmit,
  registrationError,
  regNumber,
  showError,
}: BikeRegistrationFormProps) => (
  <div
    className={`${styles.dsCard} p-20 md:p-24 lg:p-24 flex flex-col gap-20 lg:gap-24 ${className}`.trim()}
    data-bg="white"
    data-variant="outlined">
    {heading ? (
      <Typography scale="xl" emphasis="medium" as="h3" color="primary" className={headingClassName}>
        {heading}
      </Typography>
    ) : null}
    {/* TextInput does not expose onBlur; this captures focus leaving the input wrapper for old-widget validation. */}
    <div
      onBlurCapture={event => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          void onBlur()
        }
      }}>
      <TextInput
        label=""
        placeholder={inputPlaceholder}
        value={regNumber}
        onChange={onChange}
        size="lg"
        state={showError ? 'error' : 'default'}
        errorText={showError ? registrationError : undefined}
        className={styles.mobileTextInput}
      />
    </div>
    <div className="flex flex-col gap-12 items-center w-full">
      <Button
        type="button"
        variant="primary"
        size="lg"
        fullWidth
        disabled={isFetching}
        loading={isFetching}
        onClick={() => {
          void onSubmit()
        }}>
        {ctaText}
      </Button>
      {disclaimer && (
        <Typography scale="xs" color="secondary" className="opacity-70">
          {disclaimer}
        </Typography>
      )}
    </div>
  </div>
)
